import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Chart from "react-apexcharts";
import './radial-chart.styles.scss'
var _ = require('lodash');

function CustomRadialChart(props) {
  const [series, setSeries] = useState(props.series);
  const [options, setOptions] = useState({});
  let innerContent = useRef(props.innerText);

  const prepareChart = (properties) => {
    const { colors, labels, title, series, innerText} =properties;
    innerContent.current = innerText;
    const validData = _.filter(series, (value)=>{
      return _.isNumber(value) && !_.isNaN(value);
    });
    let len = labels.length;
    if(_.isEmpty(validData)){
      while(len !== 0){
        validData.push(0);
        len--;
      }
    }
    let opts = {
      chart: {
        height: 350,
        type: 'radialBar',
      },
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              fontSize: '12px',
            },
            value: {
              show:true,
              fontSize: '12px',
              offsetY:'-2px',
              formatter: function (val){return val;}
            },
            total: {
              show: true,
              label: title,
              fontSize:'12px',
              formatter: function (w) {
                return `${innerContent.current}%`
              }
            }
          }
        }
      },
      labels: labels,
    }

    if(colors) {
      opts.colors = colors;
    }
    setOptions(opts);
    setSeries(validData);
  }
  
  useEffect(() => {
     prepareChart(props);
  }, [props]);
  
  return  <Chart className="cv-radial-chart" options={options} series={series} type="radialBar" width={props?.width ? props.width : 200} />;
  
}

export default CustomRadialChart;
